<template>
  <img class="brand-logo" src="../../assets/rainbow.png" alt="Rainbow Manager" />
</template>
<style scoped lang="scss">
.brand-logo {
  display: block;
  height: 26px;
  width: auto;
  max-width: 40px;
  object-fit: contain;
}
</style>
